module.exports = __webpack_public_path__ + "assets/img/news-content.31188843.png";